import { SessionContext } from '@contexts/session-context';
import { useContext, useEffect, useMemo } from 'react';

const Strollr = () => {
  const sessionContext = useContext(SessionContext);
  const session = sessionContext?.session;
  const user = session?.user;

  const accountId = useMemo(() => {
    return (
      document.location.host.replace('.testsigma.com', '-') +
      session?.tenant?.identityServiceId +
      ':' +
      session?.user?.identityUserAccountUUId
    );
  }, [session]);

  useEffect(() => {
    // Set the log level to 'debug'.
    if (window?.Strollr?.logLevel) {
      window.Strollr.logLevel('debug');
    }

    // Identify the user using Strollr.
    if (window?.Strollr?.identify) {
      window.Strollr.identify(import.meta.env.VITE_STROLLR_API_KEY, {
        userId: accountId,
        productId: import.meta.env.VITE_STROLLR_PRODUCT_ID,
        email: user?.email,
        firstName: user?.firstName,
        lastName: user?.lastName,
        properties: {
          isAdmin: user?.isAdmin,
          plan: session?.tenant?.subscription?.plan,
          planStatus: session?.tenant?.subscription?.status,
          totalParallelRuns: session?.tenant?.subscription?.totalParallelRuns,
        },
      });
    }
  }, []);

  return null;
};

export default Strollr;
